<template>
  <div class="stepper-box">
    <button class="stepper-control minus" :disabled="currentValue <= min" @click="minus"><icon icon-class="minus"></icon></button>
    <input type="number" class="stepper-typer" :value="currentValue" v-ios-bug-fixed @input="onInput" @focus="onFocus" @blur="onBlur" name="">
    <button class="stepper-control plus" :disabled="currentValue >= max" @click="plus"><icon icon-class="plus"></icon></button>
  </div>
</template>

<style lang="less">
  .stepper-box{
    width: 120px;
    height: 32px;
    border: 1px solid #E6E9E9;
    background: #FFF;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .stepper-control{
      width: 32px;
      height: 100%;
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0;
      background: #F7F9FA;
      color: #5D8586;
      font-size: 12px;
      font-weight: bold;
      &.minus{
        border-right: 1px solid #E6E9E9;
      }
      &.plus{
        border-left: 1px solid #E6E9E9;
      }
      &:active{
        background: #F7F9FA;
      }
      &:disabled{
        color: #9FACAD;
      }
    }
    .stepper-typer{
      flex: 1;
      width: 48px;
      text-align: center;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #666;
    }
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      value: {
        default: 1
      },
      min: {
        default: 1
      },
      max: {
        default: Infinity
      },
      step: {
        default: 1
      },
      integer: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      const value = this.range(this.isDef(this.value) ? this.value : this.defaultValue);
      if (value !== +this.value) {
        this.$emit('input', value);
      }
      return {
        currentValue: value
      }
    },
    watch: {
      value(val) {
        if (val !== this.currentValue) {
          this.currentValue = this.format(val);
        }
      },
      currentValue(val) {
        this.$emit('input', val);
        this.$emit('change', val);
      }
    },
    methods: {
      isDef(value) {
        return value !== undefined && value !== null;
      },
      format(value) {
        value = String(value).replace(/[^0-9.-]/g, '');
        return value === '' ? 0 : this.integer ? Math.floor(value) : +value;
      },
      plus() {
        this.onChange('plus');
      },
      minus() {
        this.onChange('minus');
      },
      onInput(event) {
        const { value } = event.target;
        const formatted = this.format(value);

        if (+value !== formatted) {
          event.target.value = formatted;
        }
        this.currentValue = formatted;
      },
      onChange(type) {
        const diff = type === 'minus' ? -this.step : +this.step;
        const value = Math.round((this.currentValue + diff) * 100) / 100;

        this.currentValue = this.range(value);
      },
      onFocus() {
        this.$emit('focus', event);
      },
      onBlur(event) {
        this.currentValue = this.range(this.currentValue);
        this.$emit('blur', event);

        if (this.currentValue === 0) {
          event.target.value = this.currentValue;
        }
      },
      range(value) {
        return Math.max(Math.min(this.max, this.format(value)), this.min);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/stepper.vue